import React from 'react'
import {PiCheckCircleFill} from "react-icons/pi";

interface Props {}

const TemplateCard = ({img, title, value ,sk, desc, curKey, More}) => {

    // const location = useLocation();
    // const query = new URLSearchParams(location.search);
    // const isDebug = query.get("isDebug");
    //
    // const { user, isAuthenticated, isLoading, logout, loginWithRedirect } = useAuth0();
    // const { data, runFetch } = useSnapshot(VIPStore);
    // console.log(20, data);
    const isSelect = value === curKey;

  return (
    <>
        <div className={`card bg-[#F6F7FC] rounded-3xl w-56 shadow-sm mt-1  ${isSelect ? "shadow-2xl" : ""}
        transition  duration-150 ease-in-out hover:-translate-y-0.5 hover:scale-102 hover:shadow-xl
        relative font-inter
        `}

        onClick={() => {sk(value)}}
        >
            {/*<figure className={"bg-amber-400 h-7  "}>*/}
            {/*    <Icon className="text-2xl font-thin text-[#A4A4A4] absolute translate-y-1/2 left-3.5" />*/}
            {/*</figure>*/}
            <div className="card-body p-4">
                <img
                    src={img}
                    className="w-8 h-8 bg-[#242630] rounded-full p-2
                                "
                />
                <div className="text-[16px] text-[#242630]" >{title}</div>
                <div className="text-[14px] text-[#242630] mt-[-8px] opacity-60">{desc}</div>
                {
                    More !== null &&
                    <More/>
                }
            </div>
            {
                isSelect &&

            <div className="
            absolute bottom-[-4px] right-[-4px]   rounded-full
            "><PiCheckCircleFill className={"text-2xl text-[#4B5563]"}/></div>
            }



        </div>
    </>
  )
}

export default TemplateCard
